export default __webpack_public_path__ + "static/media/moon_walk.3d353399.svg";